import React, { Component } from "react";
import { Container } from "react-bootstrap";
import "./dashboard.scss";

class DashboardComponent extends Component {
  render() {
    return <Container></Container>;
  }
}

export const Dashboard = DashboardComponent;
